export default class HttpError extends Error {
  public response: Response | undefined;

  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
